// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://smilingsn.com/api';

export const API_ENDPOINTS = {
  CONTACT_SUBMIT: `${API_BASE_URL}/contact/submit.php`,
  // Futurs endpoints
  // TOURS_LIST: `${API_BASE_URL}/tours/list.php`,
  // BOOKINGS_CREATE: `${API_BASE_URL}/bookings/create.php`,
};

export default API_BASE_URL;
